export default "__VITE_ASSET__hdBip1ti__"